module.exports = __webpack_public_path__ + "img/verimor-logo.aae87aa6.svg";